var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{ref:"chart",attrs:{"unit":_vm.unit,"scale":_vm.scale,"title":"6 Month (%)","loading":_vm.loading,"daterange":_vm.daterange}})
}
var staticRenderFns = []

export { render, staticRenderFns }